import { render, staticRenderFns } from "./VCRadar2023.vue?vue&type=template&id=b1973aae"
import script from "./VCRadar2023.vue?vue&type=script&lang=js"
export * from "./VCRadar2023.vue?vue&type=script&lang=js"
import style0 from "./VCRadar2023.vue?vue&type=style&index=0&id=b1973aae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports